/* eslint-disable no-console */
/* eslint-disable import/extensions */
import React, { useContext, useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { FacebookIcon, FacebookShareButton, WhatsappShareButton, WhatsappIcon, TwitterShareButton, TwitterIcon, LinkedinIcon, LinkedinShareButton, TelegramIcon, TelegramShareButton } from 'react-share';
import { TextField, Button } from '@mui/material';
import '../../ConnectionsNew/components/styles.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { LanguageContext } from '../../../libs/Context';
import useGmail from '../../../libs/CustomHooks/useGmail';

const SharePost = (props:any) =>
{
	const { handleCloseShare, meetingId, mediaData, type, meetingVC } = props;
	const blockRef = useRef<boolean>(false);
	const { language } = useContext(LanguageContext);
	const gmailBody = type === 'meetingVC' ? meetingVC : `${process.env.REACT_APP_SHAREURL_FEED}${window.btoa(mediaData._id)}`;
	const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&body=${gmailBody}`;
	const { handleOpenGmail, windowSize, handleOpenInsta } = useGmail();
	const sharepostUrl = `${process.env.REACT_APP_SHAREURL_FEED}${window.btoa(mediaData._id)}`;
	const shareMeetingUrl = `${process.env.REACT_APP_SHAREURL_PATHNAME}conference/register/${window.btoa(meetingId)}?role=4`;

	const copyLink = (e) =>
	{
		e.preventDefault();
		if (!blockRef.current)
		{
			navigator.clipboard.writeText(type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl)
				.then(() =>
				{
					console.log('Text copied to clipboard');
					toast.info(`${language?.copiedSuccess}`, {});
				})
				.catch((err) =>
				{
					console.error('Failed to copy text: ', err);
				});
			setTimeout(() =>
			{
				blockRef.current = false;
			}, 3000);
		}
	};

	return (
		<>
			<div className='flexRow pdngXS brdrBSM alignCntr whiteBg'>
				<div className='flexMinWidthRow pdngHXS'>
					<span className='mainHdngTxt ellipsisTxt '>{language?.share}</span>
				</div>
				<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }} className='flexAutoRow pointer pdngRXS' onClick={handleCloseShare}>
					<CloseIcon />
				</button>
			</div>
			<div className='flexMinHeightCol scrollY pdngXS'>
				<div className='flexRow pdngXS'>
					<span className='lightTxt'>{language?.copyInviteLink}</span>
				</div>
				<div className='flexRow pdngVXS'>
					<div className='flexMinWidthRow pdngHXS'>
						<TextField
							fullWidth
							variant='outlined'
							type='text'
							size='small'
							className='modeGray'
							value={type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
						/>
					</div>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && copyLink(e); }} className='flexAutoRow pdngHXS' onClick={copyLink}>
						<Button
							type='button'
							variant='contained'
							size='small'
							fullWidth
							disableElevation
							disableRipple
							className='whiteTxt'
						>
							{language?.copy}
						</Button>
					</button>
				</div>
				<div className='flexWrap mrgnTMD'>
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<WhatsappShareButton
									url={type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
									className='flexInline'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }}
									onClick={handleCloseShare}
									windowWidth={windowSize.width} windowHeight={windowSize.height}
								>
									<WhatsappIcon iconFillColor='white' round size={48}/>
								</WhatsappShareButton>
							</div>
							<span className='LightTxt pdngVXS'>{language?.whatsApp }</span>
						</div>
					</div>
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<FacebookShareButton
									url={type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
									className='flexInline'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }}
									onClick={handleCloseShare}
									windowWidth={windowSize.width} windowHeight={windowSize.height}
								>
									<FacebookIcon iconFillColor='white' round size={48}/>
								</FacebookShareButton>
							</div>
							<span className='LightTxt pdngVXS'>{language?.facebook}</span>
						</div>
					</div>
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<TwitterShareButton
									url={type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
									className='flexInline'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }}
									onClick={handleCloseShare}
									windowWidth={windowSize.width} windowHeight={windowSize.height}
								>
									<TwitterIcon iconFillColor='white' round size={48}/>
								</TwitterShareButton>
							</div>
							<span className='LightTxt pdngVXS'>{language?.twitter}</span>
						</div>
					</div>
					{/* <div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<LinkedinShareButton
									url={type === 'sharemeeting' ? 
									shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
									className='flexInline'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }}
									onClick={handleCloseShare}
									windowWidth={windowSize.width} windowHeight={windowSize.height}
								>
									<LinkedinIcon iconFillColor='white' round size={48}/>
								</LinkedinShareButton>
							</div>
							<span className='LightTxt pdngVXS'>{language?.linkedIn}</span>
						</div>
					</div> */}
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<TelegramShareButton
									url={type === 'sharemeeting' ? shareMeetingUrl : type === 'meetingVC' ? meetingVC : sharepostUrl}
									className='flexInline'
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleCloseShare(); }}
									onClick={handleCloseShare}
									windowWidth={windowSize.width} windowHeight={windowSize.height}
								>
									<TelegramIcon iconFillColor='white' round size={48}/>
								</TelegramShareButton>
							</div>
							<span className='LightTxt pdngVXS'>{language?.telegram}</span>
						</div>
					</div>
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr' >
							<button tabIndex={0} className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer' onKeyUp={(e) => { e.key === 'Enter' && handleOpenInsta(); }} onClick={handleOpenInsta}>
								<div className='flexInline inviteLogo alignCntr justifyCntr'>
									<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='48' height='48' viewBox='0 0 48 48'>
										<defs>
											<linearGradient id='linear-gradient' x1='0.146' y1='0.854' x2='0.854' y2='0.146' gradientUnits='objectBoundingBox'>
												<stop offset='0' stopColor='#ffd521'/>
												<stop offset='0.055' stopColor='#ffd020'/>
												<stop offset='0.124' stopColor='#fec01e'/>
												<stop offset='0.2' stopColor='#fca71b'/>
												<stop offset='0.282' stopColor='#fa8316'/>
												<stop offset='0.368' stopColor='#f85510'/>
												<stop offset='0.456' stopColor='#f51e09'/>
												<stop offset='0.5' stopColor='#f30005'/>
												<stop offset='0.503' stopColor='#f20007'/>
												<stop offset='0.597' stopColor='#e1003b'/>
												<stop offset='0.688' stopColor='#d30067'/>
												<stop offset='0.776' stopColor='#c70088'/>
												<stop offset='0.859' stopColor='#bf00a0'/>
												<stop offset='0.936' stopColor='#bb00af'/>
												<stop offset='1' stopColor='#b900b4'/>
											</linearGradient>
											<clipPath id='clip-Artboard_20'>
												<rect width='48' height='48'/>
											</clipPath>
										</defs>
										<g id='Artboard_20' data-name='Artboard – 20' clipPath='url(#clip-Artboard_20)'>
											<g id='Group_14531' data-name='Group 14531' transform='translate(1.505 1.505)'>
												<path id='Path_18720' data-name='Path 18720' d='M22.5,44.99h0A22.5,22.5,0,0,1,0,22.5H0A22.5,22.5,0,0,1,22.5,0h0a22.5,22.5,0,0,1,22.5,22.5h0A22.5,22.5,0,0,1,22.5,44.99Z' fill='url(#linear-gradient)'/>
												<g id='Group_10288' data-name='Group 10288' transform='translate(7.135 7.14)'>
													<path id='Path_18721' data-name='Path 18721' d='M173.96,161.467c4.1,0,4.585.014,6.2.09a8.425,8.425,0,0,1,2.852.531A5.078,5.078,0,0,1,185.927,165a8.542,8.542,0,0,1,.531,2.852c.072,1.62.09,2.106.09,6.2s-.014,4.585-.09,6.2a8.425,8.425,0,0,1-.531,2.852,5.078,5.078,0,0,1-2.911,2.911,8.543,8.543,0,0,1-2.852.531c-1.62.072-2.106.09-6.2.09s-4.584-.013-6.2-.09a8.426,8.426,0,0,1-2.852-.531,5.078,5.078,0,0,1-2.911-2.911,8.54,8.54,0,0,1-.531-2.852c-.072-1.62-.09-2.106-.09-6.2s.013-4.585.09-6.2a8.425,8.425,0,0,1,.531-2.852,5.078,5.078,0,0,1,2.911-2.911,8.542,8.542,0,0,1,2.852-.531c1.62-.076,2.106-.09,6.2-.09m0-2.767c-4.171,0-4.692.018-6.33.094a11.287,11.287,0,0,0-3.73.715,7.413,7.413,0,0,0-2.717,1.768A7.558,7.558,0,0,0,159.41,164a11.354,11.354,0,0,0-.715,3.73c-.076,1.638-.094,2.16-.094,6.33s.018,4.692.094,6.33a11.289,11.289,0,0,0,.715,3.73A7.878,7.878,0,0,0,163.9,188.6a11.354,11.354,0,0,0,3.73.715c1.638.077,2.16.095,6.33.095s4.692-.018,6.33-.095a11.287,11.287,0,0,0,3.73-.715,7.878,7.878,0,0,0,4.486-4.495,11.354,11.354,0,0,0,.715-3.73c.076-1.638.094-2.16.094-6.33s-.018-4.692-.094-6.33a11.287,11.287,0,0,0-.715-3.73,7.878,7.878,0,0,0-4.495-4.486,11.355,11.355,0,0,0-3.73-.715c-1.633-.072-2.155-.09-6.326-.09Z' transform='translate(-158.6 -158.7)' fill='#fff'/>
													<path id='Path_18722' data-name='Path 18722' d='M332.587,324.7a7.887,7.887,0,1,0,7.887,7.887A7.888,7.888,0,0,0,332.587,324.7Zm0,13.007a5.12,5.12,0,1,1,5.12-5.12A5.12,5.12,0,0,1,332.587,337.707Z' transform='translate(-317.227 -317.232)' fill='#fff'/>
													<circle id='Ellipse_702' data-name='Ellipse 702' cx='1.845' cy='1.845' r='1.845' transform='translate(21.712 5.313)' fill='#fff'/>
												</g>
											</g>
										</g>
									</svg>

								</div>
							</button>
							<span className='LightTxt pdngVXS'>{language?.instagram}</span>
						</div>
					</div>
					<div className='SocialMediaIcon'>
						<div className='flexCol alignCntr justifyCntr'>
							<div className='flexRow alignCntr justifyCntr pdngXS brdrRadiusSM whiteBg shareIcon pointer'>
								<button className='flexInline inviteLogo alignCntr justifyCntr' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOpenGmail(gmailUrl); }} onClick={() => handleOpenGmail(gmailUrl)}>
									<img src='/images/icons/gmail.svg' alt='gmailsvg'/>
								</button>
							</div>
							<span className='LightTxt pdngVXS'>{language?.gmail}</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SharePost;